import FormControl from "common/components/FormControl/FormControl";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CrudForm from "common/components/Crud/CrudForm";
import type { Tag } from "types";

type Props = {
  onSubmit: (values: any) => any;
  onCancel?: () => void;
  item?: Tag;
};

function TagForm({ onSubmit, onCancel, item }: Props) {
  const { t } = useTranslation();

  const initialValues = useMemo(
    () =>
      item?.id
        ? {
            ...item,
          }
        : {},
    [item]
  );

  return (
    <CrudForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
      headerIcon="TagIcon"
      i18nNamespace="tags"
      render={() => (
        <div className="white-box flex flex-col gap-2">
          <FormControl name="name" title={t("tags.name")} required />
        </div>
      )}
    />
  );
}

export default TagForm;
